import { updateUserBoteriaService } from '../../../services/boteria/UpdateOrg';

export function updateUserBoteriaAction (code, userData, token, tokenPartners) {
	return {
		type: 'UPDATE_USER_BOTERIA',
		payload: updateUserBoteriaService(code, userData, token, tokenPartners)
	}
}